import type { FilterRangeItem, FilterSelectItem } from '@jane/search/types';

import { FilterButtonGrid } from '../filter.styles';
import { FilterButton } from '../filterButton';
import { FilterSlider } from '../filterSlider';
import { NestedRangeWrapper } from './filterModal.styles';
import type { FilterModalSectionProps } from './filterModal.types';
import { ModalSection } from './modalSection';

export const FilterModalSection = ({
  filterGroup,
  hideCounts,
  onChange,
  onDeselect,
}: FilterModalSectionProps) => {
  const { items, label, key, nested, type } = filterGroup;

  const itemsPerRow = label === 'Categories' ? 3 : label === 'Specials' ? 2 : 4;

  const isRange = type === 'range';

  const renderedItems = items.map((item) => {
    if (isRange) {
      const { key: itemKey, label: itemLabel } = item as FilterRangeItem;
      return (
        <FilterSlider
          hideCounts={hideCounts}
          item={item as FilterRangeItem}
          key={itemLabel}
          onChange={onChange}
          onDeselect={() => onDeselect(itemKey)}
        />
      );
    }

    return (
      /**
       * If the filter is for a bundle special, we hide the counts. Algola returns one count for qualifying
       * products and one for discountable products, but these can't simply be added together since it is
       * possible for a product to be in both groups and there is not a straightforward way to find the amount
       * of overlap.
       */
      <FilterButton
        filterKey={filterGroup.key}
        hideCounts={hideCounts || item.key === 'applicable_bundle_special_ids'}
        item={item as FilterSelectItem}
        key={item.label}
        onChange={onChange}
        ariaLabel={`${label} - ${item.label}`}
      />
    );
  });

  if (isRange) {
    return (
      <div data-testid="filter-modal-section">
        {nested ? (
          <NestedRangeWrapper>{renderedItems}</NestedRangeWrapper>
        ) : (
          <div>{renderedItems}</div>
        )}
      </div>
    );
  }
  return (
    <div data-testid="filter-modal-section">
      <ModalSection title={label} onDeselectClick={() => onDeselect(key)}>
        <FilterButtonGrid
          itemsPerRow={filterGroup.modalItemsPerRow || itemsPerRow}
          mobileItemsPerRow={2}
        >
          {renderedItems}
        </FilterButtonGrid>
      </ModalSection>
    </div>
  );
};
